import React from 'react';
import { FormLabel } from './UI-CHAKRA/FormLabel';
import { CustomMenuItem, CustomSelect } from './UI-CHAKRA/Select/CustomSelect';

interface SelectGenderProps {
  value: string;
  onChange(val: string): void;
  size?: 'small' | 'medium';
  error?: boolean;
  isRequired?: boolean;
  disabled?: boolean;
  hideLabel?: boolean;
}

function SelectGender(props: SelectGenderProps) {
  return (
    <>
      {!props.hideLabel && <FormLabel>Sexo{!!props.isRequired ? '*' : ''}</FormLabel>}
      <CustomSelect placeholder={'Selecione um sexo'} value={props.value} error={!!props.error}>
        <CustomMenuItem
          onClick={(value) => {
            props.onChange(String(value));
          }}
          value={'Masculino'}
          label={'Masculino'}
        />
        <CustomMenuItem
          onClick={(value) => {
            props.onChange(String(value));
          }}
          value={'Feminino'}
          label={'Feminino'}
        />
      </CustomSelect>
    </>
  );
}

export default React.memo(SelectGender);
